export const DEFAULT_PAGE_SIZE: number = 20;
export const PAGE_SIZE_10: number = 10;
export const PAGE_SIZE_7: number = 7;

export const DEFAULT_PAGE_INDEX: number = 1;
export const DEFAULT_PAGE_SIZE_FOR_FULL_TEXT_SEARCH: number = 1000;

export class Pages {
  constructor(private pageSize?: number, private page?: number) {
    if (pageSize === null || pageSize === undefined) {
      this.pageSize = DEFAULT_PAGE_SIZE + 1;
    }
    if (page === null || page === undefined) {
      this.page = DEFAULT_PAGE_INDEX;
    }
  }
}
